export default class PersonHighSchoolArchivedDomainService {
    static fromJSON(json) {
        return Object.assign(Object.assign({}, json), { startDate: json.startDate && new Date(json.startDate), endDate: json.endDate && new Date(json.endDate) });
    }
}
